
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.676 37.015h-13.34a3.334 3.334 0 01-3.334-3.335V10.337a3.334 3.334 0 013.335-3.335h21.676a3.334 3.334 0 013.334 3.335V18.5M15 19.4h5M23 19.4h6M15 13h7M29 13h-4","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.134 26c-.888 1.177-1.75 2.48-2.08 3.94-.155.681-.02 1.864 1 1.444.307-.126 1.814-1.744 1.954-1.604.238.238.106.58.611.469.475-.105.867-.491 1.215-.802.434-.387.957-.099 1.525-.048 1.002.09 2.078.712 3.05.429","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M40 24l-7 7.389-2.333-2.333","stroke":"#00B01C","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M34.684 25.15A4.781 4.781 0 0033 24.833a5 5 0 105 5","stroke":"#404040","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    